module.exports = __webpack_public_path__ + "h5/img/scan.2ca2147e.gif";